<template>
  <pop-box ref="myPopbox" class="upload-popbox" :hasNotButton="true" :title="title" @closeDialog="$emit('close')"
           :width="960">
        <el-tree
          ref="authTree"
          :data="treeData"
          :props="{label:'menuName'}"
          show-checkbox
          node-key="id"
          default-expand-all>
        </el-tree>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onSave">确定</el-button>
    </div>
  </pop-box>
</template>
<script>
  import menuTreeMixin from "@/mixin/menuTree"
  import {getAction} from "@/service/http/api";

  export default {
    name: 'Auth',
    mixins:[menuTreeMixin],
    props:['roleId','title'],
    data() {
      return{
        treeData:[],
        url:{
          list:'/permission/list',
          addMenu:'/role/addMenuToRole',
          query:'/permission/queryMenuByRoleId'
        }
      }
    },
    methods:{
      onSave(){
        let keys = [...this.$refs.authTree.getCheckedKeys(),...this.$refs.authTree.getHalfCheckedKeys()];
        getAction(this.url.addMenu,{rid:this.roleId,mids:keys.join(',')}).then(res=>{
          if(res.code==200){
            this.$message({
              message:'保存成功',
              type:"success"
            });
            this.$refs.myPopbox.isVisible = false;
            this.$emit('ok');
          }
        })
      },
      init(){
        getAction(this.url.query,{rid:this.roleId}).then(res=>{
          if(res.code===200){
            let treeMap = {};
            res.data.forEach(item=>{
              treeMap[item.id] = res.data.filter(it=>it.parentId === item.id);
            });
            let checkKeys = res.data.filter(item=>treeMap[item.id].length === 0).map(item=>item.id);
            this.$refs.authTree.setCheckedKeys(checkKeys);
          }
        })
      }
    },
    created(){
      this.getTree();
      this.init();
    },
    mounted(){
      this.$refs.myPopbox.isVisible = true;
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/role_management/auth.vue